<template>
  <main id="mainContent" ref="mainContentRef" class="payment">
    <div>
      <PaymentAlert :hasError="ftHasPaymentError" :errorMessage="ftErrorMessage"/>
      <div class="app-main-content">
          <div class="app-content-panels"><!-- prevent form stretching to full width -->
            <!-- form -->
            <form class="app-panel-left">
              <p class="app-required-indicator __before" :class="store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0 ? '' : 'noPayment'">Required field</p>
              <VeeForm ref="paymentFormRef"> 
                <div class="app-input-row" v-if="store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0">
                  <!-- CC #  -->
                  <Field name="Credit card number" v-slot="{ field, errors }" :rules="ccNumberRules">
                    <div class="app-input-group" :class="{ 'app-invalid-group': errors.length > 0 }">
                      <label for="ccNumber" class="app-required-indicator __after">Credit card (Numbers only)</label>
                      <div class="cc-img">
                        <input v-bind="field" type="text" id="ccNumber" v-model="myCardNumber" aria-describedby="ccNumberDesc" />
                        <span class="accepted-cards">
                          <img src="@ridmv/web-themes/images/icons/img_visa.svg" alt="VISA">
                          <img src="@ridmv/web-themes/images/icons/img_master.svg" alt="MasterCard">
                          <img src="@ridmv/web-themes/images/icons/img_discover.svg" alt="Discover">
                          <img src="@ridmv/web-themes/images/icons/img_amex.svg" alt="American Express">
                        </span>
                      </div>
                      <p class="error-message">{{ errors[0] }}</p> 
                      <p id="ccNumberDesc" class="sr-only">
                      Required. Accepted cards: VISA, MasterCard, Discover or American Express.
                      </p>
                    </div>
                  </Field>
                </div>

                <div class="app-input-row" v-if="store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0">
                  <!-- Expiration month -->
                  <div class="expiration-container">
                      <div class="app-label-non-control app-required-indicator __after">Expiration date (MM/YYYY)</div>
                      <div class="combo-inputs">
                          <Field name="Month" v-slot="{ field, errors }" :rules="monthRules">
                              <div class="app-input-group" :class="{ 'app-invalid-group': errors.length > 0 }">
                                  <label for="expireMonth" class="app-required-indicator __after sr-only">Expiration month</label>
                                  <input v-bind="field" type="text"  id="expireMonth" class="exp-month" ref="expireMonth" v-model="myExpireMonth" 
                                  aria-describedby="expireDateDesc" @keyup="switchFocus" />
                                  <p hidden>{{ expMonthError = errors[0] || '' }}</p>
                              </div>
                          </Field>

                          <span>/</span>

                          <!-- Expiration Year -->
                          <Field name="Year" v-slot="{ field, errors }" :rules="yearRules">
                              <div class="app-input-group" :class="{ 'app-invalid-group': errors.length > 0 }">
                                  <label for="expireYear" class="app-required-indicator __after sr-only">Expiration year</label>
                                  <input v-bind="field" type="text"  id="expireYear" class="exp-year" ref="expireYearInputRef" v-model="myExpireYear"
                                  aria-describedby="expireDateDesc"/>
                                  <p hidden>{{ expYearError = errors[0] || '' }}</p>
                              </div>
                          </Field>

                      </div><!-- combo-inputs -->
                      <p class="error-message">{{ expDateErrors }}</p>
                      <p id="expireDateDesc" class="sr-only">Required. Two-digit month and four-digit year format.</p>
                  </div><!-- /expiration-container -->

                  <!-- CVV -->
                  <Field name="CVV" v-slot="{ field, errors }" :rules="cvvRules" >
                    <div class="app-input-group" :class="{ 'app-invalid-group': errors.length > 0 }">
                      <label for="cvv" class="app-required-indicator __after">
                      CVV
                      <Tooltip theme="my-custom-tooltip" :triggers="['hover', 'click', 'focus']">
                        <button type="button" class="btn-tooltip-trigger" aria-label="CVV info">
                          <img src="@ridmv/web-themes/images/icons/question-circle-solid.svg" alt="CVV Description" class="cvv-tooltip">
                        </button>
                        <template #popper>
                          {{ cvvDescription }}
                          <span class="sr-only">{{ cvvDescription }}</span>
                        </template>
                      </Tooltip>
                      </label>
                      <input v-bind="field" type="text" id="cvv" class="cvv" aria-describedby="cvvDesc" v-model="myCvv"/>
                      <p>{{ errors[0] }}</p>
                      <p id="cvvDesc" class="sr-only">Required. Three-digit format.</p>
                    </div>
                  </Field>
                </div>

                <div class="app-input-row" v-if="store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0">
                    <!-- First name on card -->
                    <Field name="First name" v-slot="{ field, errors }" :rules="firstNameRules" >
                      <div class="app-input-group" :class="{ 'app-invalid-group': errors.length > 0 }">
                        <label for="firstName" class="app-required-indicator __after">First name</label>
                        <input v-bind="field" type="text" id="firstName" v-model="myFirstName" aria-describedby="firstNameDesc"/>
                        <p>{{ errors[0] }}</p>
                        <p id="firstNameDesc" class="sr-only">Required.</p>
                      </div>
                    </Field>

                    <!-- Last name on card -->
                    <Field name="Last name" v-slot="{ field, errors }" :rules="lastNameRules" >
                      <div class="app-input-group" :class="{ 'app-invalid-group': errors.length > 0 }">
                        <label for="lastName" class="app-required-indicator __after">Last name</label>
                        <input v-bind="field" type="text" id="lastName" v-model="myLastName" aria-describedby="lastNameDesc"/>
                        <p>{{ errors[0] }}</p>
                        <p id="lastNameDesc" class="sr-only">Required.</p>
                      </div>
                    </Field>
                </div>

                <div v-if="store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0">
                    <!-- Company name on card -->
                    <Field name="Organization name" v-slot="{ field, errors }" :rules="companyNameRules" >
                      <div class="app-input-group" :class="{ 'app-invalid-group': errors.length > 0 }">
                        <label for="companyName" style="padding-top: 0.2em">Company name</label>
                        <input v-bind="field" type="text" id="companyName" class="co" v-model="myCompanyName" aria-describedby="companyNameDesc"/>
                        <p style="width: unset;">{{ errors[0] }}</p>
                        <p id="companyNameDesc" class="sr-only">Optional.</p>
                      </div>
                    </Field>
                </div>
              </VeeForm>
              <div>
                <ContactInfo :verify="verify" @doContactValidated="setIndividualContact" ref="contactRef" :show-phone="true"/>
              </div>
          
              <div class="fees" v-if="store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0">
                  <div class="fees-list">
                    <p>Total Transaction Fee </p> <p v-if="store.state.guestLogin.totalBill.rimsTotalFeeAmount">{{ toCurrencyNum(store.state.guestLogin.totalBill.rimsTotalFeeAmount) }}</p>
                  </div>
                  <div class="fees-list">
                    <p>Service Fee for the third party provider</p> <p>{{ toCurrencyNum(store.state.guestLogin.totalBill.forteServiceFee) }}</p> 
                  </div>
                  <div class="fees-list">
                    <p> <strong>Total Bill </strong></p> <p class="total-charge">{{ toCurrencyNum(store.state.guestLogin.totalBill.totalSumFeeAmount) }}</p>
                  </div>
              </div>

              <BaseButtonGroup>
                <button type="button" @click="handleRouting(true)" :disabled="!btnComplete" :class="!btnComplete ? 'btnDisable': ''">Previous</button>
                <button type="submit" class="app-btn-primary" :disabled="!btnComplete"
                        @click.prevent="handleRouting(false)">Complete transaction(s)
                </button>
              </BaseButtonGroup>

            </form>
        </div>
      </div>
      <div v-if="store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0">
        <OneTimeToken :card-number="myCardNumber"
                      :card-month="myExpireMonth"
                      :card-year="myExpireYear"
                      :card-cvv="myCvv"
                      :fetch-token="fetchToken"
                      @doPay="parseForteResponse"/>
      </div>
    </div>
      <!-- full screen spinner -->
    <ModalSpinnerPaymentCompletion />
  </main>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'; 
import { useStore } from 'vuex'; 
import { Form as VeeForm, Field } from 'vee-validate'; 
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import ContactInfo from './ContactInfo.vue';
import { toCurrency } from '@/utils/helpers';
import OneTimeToken from '../../components/payment/OneTimeToken.vue';
import PaymentAlert from '../../components/payment/PaymentAlert.vue';
import getForteConfig from '../../components/payment/forteConfig';
import { stripExtraSpaces } from '@/utils/utils';
import { loadScript } from 'vue-plugin-load-script';
import * as COMMONS from '../../store/_commons';
import { zonedTimeToUtc } from 'date-fns-tz';
import { usePhoneFormatter } from '@/composables/usePhoneFormatter'; 
import ModalSpinnerPaymentCompletion from '@/components/appModal/ModalSpinnerPaymentCompletion';
import { Tooltip } from 'floating-vue';

// Emits
const emit = defineEmits(['getStep', 'doResetVerify']);

// Vuex store
const store = useStore();

// Composable
const { formatPhoneForRims } = usePhoneFormatter();

// Reactive data refs
const contactRef = ref(null); 
const btnComplete = ref(true); 

const ftToken = ref(undefined); 
const ftHasPaymentError = ref(false); 
const ftErrorMessage = ref('');
const fetchToken = ref(false);

const cvvDescription = 'For Discover, MasterCard and Visa, enter last three digits on the signature strip. ' +
          'For American Express, enter the four digits in small print on the front of the card.';
const myCardNumber = ref('');
const myExpireMonth = ref(''); 
const myExpireYear = ref('');  
const myCvv = ref('');

const myFirstName = ref('');
const myLastName = ref('');
const myCompanyName = ref('');

const expMonthError = ref('');
const expYearError = ref('');

const supportedCardTypes = ref([
  'amex',                 // both individual + corporate
  'disc',
  'mast',
  'visa'
]);

const verify= ref(true);
const myContact = ref(null);
const expireYearInputRef = ref(null); 

const paymentFormRef = ref(null); 
const mainContentRef = ref(null); 

const isProcessing = ref(false);

// Validation Rules computed props
const ccNumberRules = computed(() => ({
  fieldRequired: true,
  numeric: true,
  minMax: [ 13, 19 ],
}));

const cvvRules = computed(() => ({
  fieldRequired: true,
  numeric: true,
  minMax: [ 3, 4 ],
}));

const monthRules = computed(() => ({
  fieldRequired: true,
  numeric: true,
  max: 2,
  monthBetween: [ 1, 12 ],
}));

const yearRules = computed(() => ({
  fieldRequired: true,
  numeric: true,
  max: 4,
  validYear: [ 20 ], 
}));

// Combined expiration date errors
const expDateErrors = computed(() => {
  return `${expMonthError.value} ${expYearError.value}`;
});

// Hook
onBeforeUnmount(() => {
  resetData();
});

// Methods
const firstNameRules = (value) => {
  if (!value) {
    return 'First name is required.';
  }
  if (!/^[a-zA-Z0-9!@#$%^&*()_+=[\]{}\u2018\u2019':"\\.>/?`~ ]*$/.test(value)) { // Allows letters, spaces, hyphens, and periods
    return 'Special characters ";", "<", "|", "," and "-" are not allowed.' + 'For hyphenated names please use a space in place of hyphen / dash.';
  }
  if (value.length > 40) {
    return 'First name is limited to 40 characters.';
  }
  return true;
};

const lastNameRules = (value) => {
  if (!value) {
    return 'Last name is required';
  }
  if (!/^[a-zA-Z0-9!@#$%^&*()_+=[\]{}\u2018\u2019':"\\.>/?`~ ]*$/.test(value)) { 
    return 'Special characters ";", "<", "|", "," and "-" are not allowed.' + 'For hyphenated names please use a space in place of hyphen / dash.';
  }
  if (value.length > 40) {
    return 'Last name is limited to 40 characters.';
  }
  return true;
};

const companyNameRules = (value) => {
  if (!value) {
    return true; 
  }
  if (!/^[a-zA-Z0-9!@#$%^&*()_+=[\]{}\u2018\u2019':"\\.>/?`~ ]*$/.test(value)) { 
    return 'Special characters ";", "<", "|", "," and "-" are not allowed.' + 'For hyphenated names please use a space in place of hyphen / dash.';
  }
  if (value.length > 80) {
    return 'Organization name is limited to 80 characters.';
  }
  return true;
};

const getPaymentProcess = () => store.dispatch(COMMONS.GUEST_PAYMENTPROCESS);
const getSendTransactionConfiramtion = () => store.dispatch(COMMONS.GUEST_SENDTRANSACTIONCONFIRMATION);

const toCurrencyNum = (value) => {
  if (value !== null && value !== '') { 
    return toCurrency(value);
  } else {
    return '$0.00';
  }
};

const handleRouting = async (isPrev) => {
  if (isProcessing.value) {
    return;
  }
  isProcessing.value = true;

  if (isPrev) {
    window.scroll(0, 0); // focus on top of page
    emit('getStep', 4);
    store.state.guestLogin.step = 4;
    store.state.networkResponse = null;
    isProcessing.value = false; 
    return;
  } 

  // Always validate contact info
  let childIsValid = false;
  if (contactRef.value) {
    childIsValid = await contactRef.value.continueToNextStep();
  }

  // Only validate payment form if payment is required
  let formFieldsValid = true;
  const hasPaymentAmount = store.state.guestLogin.totalBill?.totalSumFeeAmount > 0;
  
  if (hasPaymentAmount && paymentFormRef.value) {
    const { valid } = await paymentFormRef.value.validate();
    formFieldsValid = valid;
  }

  const finalResult = childIsValid && formFieldsValid;
  
  if (finalResult) {
    // eslint-disable-next-line no-unused-vars
    const contactData = contactRef.value.getContactData();

    emit('doResetVerify');
    btnComplete.value = false;
    fetchToken.value = true;
    
    if (!hasPaymentAmount) {
      withoutPayment();
    }
  } else {
    await nextTick();
    if (!formFieldsValid) {
      // CC fields failed — first error is at the top of the form
      window.scroll(0, 0);
      mainContentRef.value?.focus({ preventScroll: true });
    } else {
      // Only contact info failed (e.g. email missing) — scroll to that section
      contactRef.value?.$el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  
  isProcessing.value = false;
};

const updateTransactionFees = () => {
  const cartTransactions = store.state.guestLogin.cartTransactions?.cartTransactions;
  const renewalCart = store.state.guestLogin.renewalCart;
  
  if (!cartTransactions || !renewalCart) {
    return;
  }
  
  cartTransactions.forEach((transaction, index) => {
    if (renewalCart[index]?.onlineTransactionFeeCollection) {
      transaction.transactionFees = renewalCart[index].onlineTransactionFeeCollection;
    }
  });
};

const buildCartPaymentArgs = () => ({
  authorizationNumber: '',
  paymentDate: getUtcDate(),
  paymentMakerCompanyName: stripExtraSpaces(myCompanyName.value),
  paymentMakerFirstName: stripExtraSpaces(myFirstName.value),
  paymentMakerLastName: stripExtraSpaces(myLastName.value),
  serviceFeeAmount: store.state.guestLogin.totalBill?.forteServiceFee,
  totalCartAmount: store.state.guestLogin.totalBill?.totalSumFeeAmount,
  traceNumber: '',
  transactionCartId: store.state.guestLogin.cartTransactions?.transactionCartId,
});

const buildValidationArgs = () => ({
  cartPayment: buildCartPaymentArgs(),
  cartTransactions: store.state.guestLogin.cartTransactions?.cartTransactions,
  email: contactRef.value?.myEmail || '',
  isPaperlessCommunication: true,
  phone: formatPhoneForRims(contactRef.value?.myPhone) || '',
  transactionCartId: store.state.guestLogin.cartTransactions?.transactionCartId,
});

const processFinalizeCart = async () => {
  updateTransactionFees();
  const argsFinalize = {
    paymentRequest: {
      action: 'sale',
      subtotalAmount: store.state.guestLogin.totalBill?.rimsTotalFeeAmount,
      serviceFeeAmount: store.state.guestLogin.totalBill?.forteServiceFee,
      authorizationAmount: store.state.guestLogin.totalBill?.totalSumFeeAmount,
      billingAddress: {
        firstName: stripExtraSpaces(myFirstName.value),
        lastName: stripExtraSpaces(myLastName.value)
      },
      card: {
        oneTimeToken: ftToken.value
      }
    },
    transactionCart: {
      cartPayment: buildCartPaymentArgs(),
      cartTransactions: store.state.guestLogin.cartTransactions?.cartTransactions,
      email: contactRef.value?.myEmail || '',
      isPaperlessCommunication: true,
      phone: formatPhoneForRims(contactRef.value?.myPhone) || '',
      transactionCartId: store.state.guestLogin.cartTransactions?.transactionCartId,
    },
    isConsentProvided: true,
  };

  const finalizeCart = await store.dispatch(COMMONS.GUEST_FINALIZECART, argsFinalize);
  if (finalizeCart?.status == 200) {
    const finalizeRes = finalizeCart.data;
    store.state.guestLogin.step = 6;
    store.state.guestLogin.resNotificationSent = finalizeRes.sendConfirmationResponse;
  } else {
    console.error(`Finalize Cart failed...`);
  }
};

const makePayment = async () => {
  updateTransactionFees();
  const args = buildValidationArgs();

  const validateResults = await store.dispatch(COMMONS.GUEST_VALIDATECART, args);
  const validateCartRes = validateResults.data;

  const isValidCart = validateResults.status == 200 && validateCartRes.isCartValid == true;
  if (!isValidCart) {
    setPaymentAlert(validateCartRes.message);
    return;
  }

  const hasPaymentAmount = store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0;
  if (!hasPaymentAmount) {
    withoutPayment();
    return;
  }

  try {
    await processFinalizeCart();
  } catch (err) {
    console.error(`Finalize Cart failed:`, err);
    btnComplete.value = true;
  }
};

const withoutPayment = async () => {
  try {
    for(let i in store.state.guestLogin.cartTransactions.cartTransactions) {
      store.state.guestLogin.cartTransactions.cartTransactions[i].transactionFees = store.state.guestLogin.renewalCart[i].onlineTransactionFeeCollection
    }

    const args = {
      cartTransactions: store.state.guestLogin.cartTransactions.cartTransactions,
      email: contactRef.value?.myEmail || '',
      isPaperlessCommunication: true,
      phone: formatPhoneForRims(contactRef.value?.myPhone) || '',
      transactionCartId: store.state.guestLogin.cartTransactions.transactionCartId,
    };

    const validateResults = await store.dispatch(COMMONS.GUEST_VALIDATECART, args);
    const validateCartRes = validateResults.data;

    if (validateResults.status == 200 && validateCartRes.isCartValid == true) {
      const argsFinalize = {
        transactionCart: {
          cartTransactions: store.state.guestLogin.cartTransactions.cartTransactions,
          email: contactRef.value?.myEmail || '',
          isPaperlessCommunication: true,
          phone: formatPhoneForRims(contactRef.value?.myPhone) || '',
          transactionCartId: store.state.guestLogin.cartTransactions.transactionCartId,
        },
        isConsentProvided: true,
      };
      
      const finalizeCart = await store.dispatch(COMMONS.GUEST_FINALIZECART, argsFinalize);
      if (finalizeCart.status == 200) {
          const finalizeRes = finalizeCart.data;
          store.state.guestLogin.step = 6;
          store.state.guestLogin.resNotificationSent = finalizeRes.sendConfirmationResponse;
      } else {
        console.error(`Finalize Cart failed...`);
        btnComplete.value = true;
      }
    } else {
        setPaymentAlert(validateCartRes.message);
    }
  } catch (err) {
    console.error(`Forte payment failed...`, err.message);
    btnComplete.value = true;
  }
};

/**
 * Converts local/client datetime to UTC and send it back to RIMS.
 * Note: RIMS persists all date(time) in database in ET timezone. Attempted to pre-convert UTC to EST
 * for RIMS... But it appears Chrome (v98) got confused in the process. Decided to send UTC along as
 * it's the standard. RIMS will have to deal with the datetime conversion on the backend.
 * @returns {Date}
*/
const getUtcDate = (dt) => {
  // [1] get client local datetime AND timezone
  const clientDate = dt || new Date();
  const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // [2] convert client local datetime to UTC (must specify local timezone)
  const utcDate = zonedTimeToUtc(clientDate, clientTimezone);
  // [3] send UTC datetime to RIMS (browser will get confused if UTC is converted to ET before sending... 😖)
  return utcDate.toISOString();
};

const setIndividualContact = (data) => {
  myContact.value = data;
  isFormValid();  
};

/**
 * Checks card type returned by Forte to ensure it's one of the business-predefined supported cards.
 * Note:
 *    Forte will always return 'success' and OTT even if card type is NOT supported.
 *    Forte OTT will return an error if:
 *      (1) The card type does not match the card number
 *      (2) The card is expired
 *      (3) The card number format is incorrect (including cvv)
 *      (4) Any required field is missing
 * @param type The card_type value from Forte OTT response.
 */
const isCardTypeSupported = (type) => {
  return supportedCardTypes.value.find(item => item === type);
};


let isValidationRunning = false;
const isFormValid = async () => {
  if (isValidationRunning) {
    console.log('Validation already in progress. Skipping.');
    return;
  }
  isValidationRunning = true;
  try {
    if (!paymentFormRef.value) {
      console.warn("Payment form ref is null. Cannot validate.");
      return false;
    }
    const { valid: formFieldsValid} = await paymentFormRef.value.validate();

    let myContactValid = false;

    if (contactRef.value) { 
      myContactValid = await contactRef.value?.hasContactInfo(); 
      contactRef.value.toggleRequirementError(); 
    } else {
      console.warn("ContactInfo component ref is null. Skipping contact validation.");
    }
    // Emit event
    emit('doResetVerify');

    // Final validation check 
    if (store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0) {
      // Logic for when payment is required (checking form fields AND contact info)
      return (formFieldsValid && myContactValid);
    } else {
      // Logic for when payment is NOT required (only checking contact info)
      return (myContactValid);
    }
  } finally {
    isValidationRunning = false;
  }
};


/**
 * Ensures Forte response _really really_ is good to go before processing payment.
 * @param data
*/
const parseForteResponse = async(data) => {
  const res = data.forte;
  if (data.hasOtt) {
    verifyOtt(res);
  } else {
    setPaymentAlert(parseOttError(res.response_description));
    btnComplete.value = true;
  }
  fetchToken.value = false;
}

/**
 * Converts Forte OTT response description to proper English.
 * @param desc
 * @returns {string|*}
 */
const parseOttError = (desc) => {
  if (desc && desc.endsWith('invalid.')) { 
    let msg = desc.replace('cvv', 'CVV');
    msg = msg.replace('expire_month and expire_year', 'expiration month and/or expiration year');
    msg = msg.split('_').join(' ');   // replaceAll won't work on older iOS
    return msg;
  }
  return '';
};

/**
 * Confirms that the OTT returned by Forte contains a supported card type before making payment.
 * @param res
 */
const verifyOtt = (res) => { 
  const supported = isCardTypeSupported(res.card_type); 

  // make payment IFF OTT returns a supported card type
  if (supported === undefined || supported === false) { 
    setPaymentAlert('Sorry, we only support VISA, MasterCard, Discover and American Express.'); 
    btnComplete.value = true;
  } else {
    // remove existing alert banner, if any
    ftHasPaymentError.value = false; 
    ftErrorMessage.value = ''; 
    ftToken.value = res.onetime_token; 
    makePayment(); 
  }
};

const resetData = () => {
  ftToken.value = ''; 
  ftHasPaymentError.value = false; 
  ftErrorMessage.value = ''; 
  console.warn('Resetting payment data.');
};

const setPaymentAlert = (msg) => {
  ftToken.value = '';  // MUST reset OTT or payment will repeat based on # of errors prior to form submit
  ftHasPaymentError.value = true; 
  ftErrorMessage.value = msg; 
  console.log('Payment Alert Triggered:', msg);
};

/**
 * Jumps from MM to YYYY.
 * @param e
 */
const switchFocus = async (e) => {
  const isTab = e.key === 'Tab'; 
  const isShift = e.key === 'Shift';

  if (!isTab && !isShift) {
    const targetId = e.target.id;
    const targetLength = e.target.value.length;
    if (targetId === 'expireMonth' && targetLength === 2) {
      // Use nextTick to ensure the DOM is updated before focusing
      nextTick(() => { 
        expireYearInputRef.value?.focus(); 
      });
    }
  }
};

/**
 * Loads Forte JS library only when needed.
 * For some reason, the script MUST be loaded here instead of inside OneTimeToken component.
 */
const loadForteJs = async () => {
  const config = getForteConfig(); // Call the function to get the config
  console.log('forte js to be loaded...', config.url);

  try {
    await loadScript(config.url);
    // don't call getFees here to avoid dependency
  } catch (error) {
    // this should catch any network call error (no requirements specified)
    console.error(error);
  }
};

onMounted(() => {
  window.scroll(0, 0); 

  if (mainContentRef.value) { 
    mainContentRef.value?.focus();
  } else {
    // Fallback or warning if the element isn't found via ref
    console.warn("Element with ref 'mainContentRef' not found. Attempting fallback via ID.");
    const mainContentElement = document.getElementById("mainContent");
    if (mainContentElement) {
        mainContentElement.focus();
    } else {
        console.error("Element with ID 'mainContent' not found.");
    }
  }

  document.body.setAttribute("tabindex", "1");
  document.body.focus();
  document.body.removeAttribute("tabindex");

  // Call the function
  loadForteJs();
});


defineExpose({
  getPaymentProcess,
  getSendTransactionConfiramtion,
  toCurrencyNum,
  setIndividualContact,
  isCardTypeSupported,
  isFormValid,
  paymentFormRef,
  contactRef,
  setPaymentAlert,
  mainContentRef,
  resetData,
  verifyOtt,
  parseOttError,
  parseForteResponse,
  withoutPayment
});
</script>


<style lang="scss" scoped>
.payment {
  input {
    &.exp-month, &.exp-year, &.cvv {
      text-align: center;
    }
    &.co {
      width: 100%;
    }
    &.exp-month {
      max-width: 3.5em;
    }
    &.exp-year, &.cvv {
      max-width: 5em;
    }
  }

  .noPayment {
    margin-bottom: 1rem;
  }

  .cc-img {
    display: flex;
    flex-wrap: wrap;
    #ccNumber {
      margin-right: 0.75em;
      width: 330px;
    }
    .accepted-cards {
      display: flex;
      gap: 0.5em;
      img {
        margin-top: 0.15em; // for wrapped images on small screens
        width: 39px;
      }
    }
    ~ .error-message {
      color: var(--ri-red);
      @extend %font-sans-regular;
      padding-top: 0.5em;
    }
  }

  .expiration-container {
    // could limit container width, if needed
    .combo-inputs {
      display: flex;
      gap: 0.35em;
      span:nth-child(2) {
        padding-top: 0.65em;
      }
    }
  }

  .error-message {
    color: var(--ri-red);
    line-height: 1.35em;
    padding-top: unset;
    padding-bottom: 1.25em;
  }

  .app-required-indicator {
    display: flex;
    gap: 0.5rem;
    .cvv-tooltip{
      width: 20px;
    }
    .btn-tooltip-trigger{
      min-width: 25px;
      border: none;
      background-color: unset;
      border-radius: unset;
      padding: 0rem;
      margin-bottom: 0rem;
    }
  }
}

.fees {
  background-color: #1B243B;
  color: white;
  margin-bottom: 10px;
  .fees-list{
    display: flex;
    justify-content: space-between;
    p {
      font-size: 16px;
      line-height: 23px;
      padding: 10px;
    }
    .total-charge{
      color: #FFA500;
      font-weight: 700;
      width: 100px;
      text-align: right;
    }
  }
}

.btnDisable{
  background-color: #fff !important;
  color: var(--ri-blue);
}

button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
    margin-right: 1em;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}

@media only screen and (min-width: 500px) and (max-width: 743px) {
  .co {
    width: 420px !important;
  }
}
</style>
  